<div class="itinerary-flight-container">
    <div class="airports">
        <div class="airport">
            <span class="airport_label">Saida</span>
            <span class="airport_info">
                {{ flight.flightSegments[0].originLocationCode }}<strong class="hour">{{
                    flight.flightSegments[0].departureDateTime | dateFormat: 'HH:mm' }}</strong>
            </span>
            <span class="airport_city">{{ flight.flightSegments[0].originCityName.toLowerCase() }}</span>
            <span class="airport_city">{{ flight.flightSegments[0].originLocationCode }}</span>
        </div>

        <div class="airport">
            <span class="airport_label">Chegada</span>
            <span class="airport_info">
                {{ flight.flightSegments[0].destinationLocationCode }}<strong class="hour">{{
                    flight.flightSegments[0].arrivalDateTime | dateFormat: 'HH:mm' }}</strong>
            </span>
            <span class="airport_city">{{ flight.flightSegments[0].destinationCityName}}</span>
            <span class="airport_city">{{ flight.flightSegments[0].destinationLocationCode }}</span>
        </div>

        <div class="airport">
            <span class="airport_label">Saida</span>
            <span class="airport_info">
                {{ flight.flightSegments[1].originLocationCode }}<strong class="hour">{{
                    flight.flightSegments[1].departureDateTime | dateFormat: 'HH:mm' }}</strong>
            </span>
            <span class="airport_city">{{ flight.flightSegments[1].originCityName}}</span> 
            <span class="airport_city">{{ flight.flightSegments[1].originLocationCode }}</span>
        </div>

        <div class="airport">
            <span class="airport_label">Chegada</span>
            <span class="airport_info">
                {{ flight.flightSegments[1].destinationLocationCode }}<strong class="hour">{{
                    flight.flightSegments[1].arrivalDateTime | dateFormat: 'HH:mm' }}</strong>
            </span>
            <span class="airport_city">{{ flight.flightSegments[1].destinationCityName }}</span>
            <span class="airport_city">{{ flight.flightSegments[1].destinationLocationCode }}</span>
        </div>

    </div>


    <div class="airports">
        <div class="flight-route">
            <span class="flight-route_eclipse"></span>

            <div class="flight-route_stop">
                <span class="flight-route_eclipse map-pointer"></span>
            </div>
        </div>

        <div class="flight-duration">
            <span class="flight-duration_label"> </span>
            <span class="flight-duration_time"></span>
        </div>

        <div class="flight-route">
            <span class="flight-route_eclipse"></span>


            <div class="flight-route_stop">
                <span class="flight-route_eclipse map-pointer"></span>
            </div>
        </div>


    </div>

    <div class="airports">

        <div class="flight-duration-a">
            <span class="flight-duration_label-a">Duração</span>
            <span class="flight-duration_time_a"> {{flight.flightSegments[0].duration}}</span>
        </div>


        <div class="flight-duration-b">
            <span class="flight-duration_label-b">Duração</span>
            <span class="flight-duration_time_b"> {{flight.flightSegments[1].duration}}</span>
        </div>



    </div>



</div>